import script from "./HotelRoomStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelRoomStatus.vue?vue&type=script&setup=true&lang=js"

import "./HotelRoomStatus.vue?vue&type=style&index=0&id=3b00d56a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b00d56a"]])

export default __exports__